<template>
    <div class="qrcode-box" v-show="value">
        <div class="qrcode-center">
            <div class="qrcode" style="font-size:16px;color:#000000;font-weight:bold;font-family: PingFangSC, PingFangSC-Medium;">

                <p style="vertical-align:middle;">·  <img  src="@/assets/images/connect/connect.png" alt="">
                    <a style="color:#000000;" :href="'tel:' + 4009882007">  400 988 2007</a>
                </p>
                <p ><br> </p>
                <p style="font-size: 14px;color:#666666;padding-left: 10px;font-weight: 400;">工作时间：周一至周五9:00-17:00</p>
                <p ><br> </p>
                <p ><br> </p>
                <p style="vertical-align:middle;">
                    · <img  src="@/assets/images/connect/write.png" alt="">
                    <a style="color:#000000;font-weight:bold;line-height: 34px;border-bottom: 1px solid;padding-bottom: 5px;"
                       href="https://www.wjx.cn/vj/eFMhdw4.aspx">
                        填写需求，专属顾问与您联系
                    </a>
                </p>

            </div>
            <p style="font-size: 14px;color:#ffffff; margin-top: -1px;margin-bottom: -2px;">| </p>
            <div class="close" @click="close">
                <img src="@/assets/images/close.png" alt="">
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        name: 'qrcode',
        props: {
            value: {
                type: Boolean,
                default: false
            }
        },
        watch: {
            value (val) {
                document.body.style.overflow = val ? 'hidden' : 'auto';
            }
        },
        methods: {
            close(){
                this.$emit('input', false);
            }
        }
    }
</script>
<style lang="less" scoped>
    .qrcode-box {
        width: 100%;
        height: 100%;
        background:rgba(0, 0, 0, 0.5);
        position: fixed;
        top:0;
        text-align: center;


        .qrcode-center{
            width: 100%;
            height: 400px;
            position: absolute;
            left: 0;
            right: 0;
            bottom: 0;
            top:0;
            margin: auto;

            .qrcode{
                width: 75%;
                height: 300px;
                opacity: 1;
                background: #ffffff;
                border-radius: 10px;
                margin-top: 0;
                margin-left:auto;
                margin-right:auto;

                vertical-align: middle;
                text-align: left;

                font-size: 16px;
                padding: 80px 0 0 40px;
                img{
                    width: 48px;
                    height: 48px;
                }
            }
            .close{
                text-align: center;
                img{

                    width: 45px;
                    height: 45px;
                }
            }
        }

    }
</style>